module.exports = __webpack_public_path__ + "static/paso-2-0a8acce308392e72235d18d3f12dde04.png";